export const shuffleList = <T>(items: Array<T>, fixedCount = 0): Array<T> => {
  const splitIndex = Math.min(fixedCount, items.length);
  const locked = items.slice(0, splitIndex);
  const toShuffle = items.slice(splitIndex);

  for (let i = toShuffle.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [toShuffle[i], toShuffle[j]] = [toShuffle[j], toShuffle[i]];
  }

  return [...locked, ...toShuffle];
};
